import { PermissionClaim } from '@eta/components/dist/authentication/Claim';
import { authService } from '../Security/Security';

export class ClaimsHelper {
    public static UserBranches() {
        const branches = authService.currentUser?.profile?.Branches;
        return branches;
    }

    public static UserPermissions() {
        const permissions = authService.currentUser?.profile?.Permissions;
        return permissions;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static canSubmitComplaints(): boolean {
        const perm = PermissionClaim.SubmitComplaint;
        const userProfile = authService.currentUser?.profile;
        if (
            userProfile?.Permissions &&
            userProfile?.Permissions?.includes(perm)
        ) {
            return true;
        }
        return false;
    }
    
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static hasPermission(perm: any, branchId?: any) {
        const userProfile = authService.currentUser?.profile;
        if (
            userProfile?.Permissions &&
            userProfile?.Permissions?.includes(perm)
        ) {
            if (
                branchId &&
                userProfile?.Branches &&
                userProfile?.Branches.length > 0
            ) {
                return userProfile?.Branches.includes(branchId);
            }
            return true;
        }
        return false;
    }

    public static IsTaxRepres() {
        const isTaxRepres = authService.currentUser?.profile?.isTaxRepres;
        return isTaxRepres === '1';
    }

    public static IsSystem() {
        const isSystem = authService.currentUser?.profile?.IsSystem;
        return isSystem === '1';
    }

    public static IsIntermediary() {
        const isIntermediary = authService.currentUser?.profile?.IsIntermediary;
        return isIntermediary === '1';
    }

    public static hasTag(tag: string) {
        const userProfile = authService.currentUser?.profile;
        if (
            userProfile?.TaxProfTags &&
            userProfile?.TaxProfTags?.includes(tag)
        ) {
            return true;
        }
        return false;
    }
    
    public static isB2cTagCanMngPos(): boolean {
        if (!ClaimsHelper.hasPermission(PermissionClaim.MngPOS)) return false;
        return ClaimsHelper.hasTag('B2C');
    }
}
